(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('AlertsConfigurationController', AlertsConfigurationController);

    AlertsConfigurationController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'AlertRules', '$state', '$uibModalInstance', 'AlertService', 'TabDomains', '$rootScope'];

    function AlertsConfigurationController($timeout, $scope, $stateParams, entity, AlertRules, $state, $uibModalInstance, AlertService, TabDomains, $rootScope) {
        var vm = this;
        vm.warning = entity;
        vm.throttleUnit = ["minutes", "hours", "days", "weeks"];
        vm.licence = $rootScope.licence;

        vm.warning.$promise.then(function () {
            vm.setAlertConf();
        });

        TabDomains.current(function (result) {
            vm.domain = result;
        });

        vm.clear = function() {
            $uibModalInstance.close();
        };

        vm.setAlertConf = function() {
            vm.alertUsers = [];
            vm.email = {};
            vm.slack = {};
            vm.telegram = {};
            vm.webhook = {};
            vm.email.exist = false;
            vm.slack.exist = false;
            vm.telegram.exist = false;
            vm.webhook.exist = false;
            vm.warning.warningAlertConfigurations.forEach(function (wac) {
                vm[wac.alertSystemType.name].exist = true;
                vm[wac.alertSystemType.name].wac = wac;
                if(wac.throttlePeriod < 60) {
                    vm[wac.alertSystemType.name].throttle = wac.throttlePeriod;
                    vm[wac.alertSystemType.name].time = "minutes";
                } else if(wac.throttlePeriod < (3600)) {
                    vm[wac.alertSystemType.name].throttle = wac.throttlePeriod / 60;
                    vm[wac.alertSystemType.name].time = "hours";
                } else if(wac.throttlePeriod < (3600 * 24 )) {
                    vm[wac.alertSystemType.name].throttle = wac.throttlePeriod / (60 * 24);
                    vm[wac.alertSystemType.name].time = "days";
                } else {
                    vm[wac.alertSystemType.name].throttle = wac.throttlePeriod / (60 * 24 * 7);
                    vm[wac.alertSystemType.name].time = "weeks";
                }
                if(wac.active)
                    vm[wac.alertSystemType.name].active = true;
            });
        };

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:warningUpdate', result);
            vm.isSaving = false;
            vm.warning = result;
            vm.setAlertConf();
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function (type) {
            vm.isSaving = true;
            vm.channel = {};
            vm.channel.alertSystemType = {};
            vm.channel.alertSystemType.name = type;
            vm.channel.active = true;
            vm.channel.warning = vm.warning;
            AlertRules.insertAlerts({warningAlertConfiguration : vm.channel, warning: vm.warning, users:vm.alertUsers}, onSaveSuccess, onSaveError);
        };

        vm.deleteAlert = function(type) {
            AlertRules.deleteAlerts({warningAlertConfiguration : vm[type].wac, warning: vm.warning}, onSaveSuccess, onSaveError);
        };

        vm.toggleStatus = function (type) {
            if(vm[type].exist) {
                vm[type].wac.active = !vm[type].wac.active;
                AlertRules.toggleChannel({
                    warningAlertConfiguration: vm[type].wac,
                    warning: vm.warning
                }, function (result) {
                    vm.warning = result;
                });
                vm[type].active = !vm[type].active;
            } else {
                vm.save(type);
            }
        };

        vm.saveThrottle = function (type, allWarning) {
            if(vm[type].throttle == undefined) {
                AlertService.error("Throttle time must be between 1 and 59");
            } else {
                if (vm[type].time == "minutes") {
                    vm[type].wac.throttlePeriod = vm[type].throttle;
                } else if (vm[type].time == "hours") {
                    vm[type].wac.throttlePeriod = vm[type].throttle * 60;
                } else if (vm[type].time == "days") {
                    vm[type].wac.throttlePeriod = vm[type].throttle * 60 * 24;
                } else if (vm[type].time == "weeks") {
                    vm[type].wac.throttlePeriod = vm[type].throttle * 60 * 24 * 7;
                }
                AlertRules.toggleChannel({
                    warningAlertConfiguration: vm[type].wac,
                    warning: vm.warning,
                    allWarning: allWarning
                }, function (result) {
                    vm.warning = allWarning ? result.warning : result;
                    AlertService.success(allWarning ? "Throttle time saved for all alert" : "Throttle time saved");
                }, function () {
                    AlertService.error("Error saving throttle");
                });
            }
        };

        vm.goToSettings = function () {
            $state.go('general-settings');
            vm.clear();
        };
    }
})();
